import { api } from '@/utils/axiosInstances'
import type {
  Collection,
  CountResponse,
  GameGlassUser,
  QueryParams,
  ResultsResponse,
  Shard,
} from '@/types/api'

export const getUserInfo = () =>
  api.get<GameGlassUser>('users/@me')

export const getUserCollections = (params: QueryParams = {}) =>
  api.get<ResultsResponse<Collection>>('/users/@me/collections', { params })

export const getUserShardCount = (params: QueryParams = {}) =>
  api.get<CountResponse>('/users/@me/shards/count', { params })

export const getUserShards = (params: QueryParams = {}) =>
  api.get<ResultsResponse<Shard>>('/users/@me/shards', { params })
